import React from 'react';

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div style={{
      width: '100%',
      height: 4,
      background: 'rgba(250,253,251,0.08)',
      borderRadius: 2,
      overflow: 'hidden',
    }}>
      <div style={{
        height: '100%',
        width: `${Math.min(100, Math.max(0, progress))}%`,
        background: 'var(--color-primary)',
        borderRadius: 2,
        transition: 'width 0.3s ease',
      }} />
    </div>
  );
};

export default ProgressBar;
